
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_18q5y_99",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_18q5y_145",
  "badge-color-green": "awsui_badge-color-green_1yjyg_18q5y_148",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_18q5y_151",
  "badge-color-red": "awsui_badge-color-red_1yjyg_18q5y_154"
};
  